<template>
    <div>
        <div class="container-fluid wow fadeInUp" data-wow-delay="0.1s">
            <div class="container">
                <div class="row">
                    <div class="col-12 text-center">
                        <div :style="{ display: 'flex', 'justify-content': 'center' }">
                            <a  :href="'/payment?id='+priceDetail.subscriptionPrice._id" class="btn btn-success pricing-plan-purchase-btn">Subscription ({{ formatCurrency(priceDetail.subscriptionPrice.amount) }})</a>
                            <a :href="'/payment?id='+priceDetail.oneTimePrice._id" class="btn btn-primary pricing-plan-purchase-btn">Onetime ({{ formatCurrency(priceDetail.oneTimePrice.amount) }})</a>
                        </div>
                        <nav aria-label="breadcrumb" class="float-right">
                            <ul class="breadcrumb">
                                <li class="breadcrumb-item"><a href="javascript:void(0)" @click="$router.push({ path: '/'})">Home</a></li>
                                <li class="breadcrumb-item active" aria-current="page">Power On Boot</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        <!-- About Start -->
        <div class="container-fluid wow fadeInUp" data-wow-delay="0.1s">
            <div class="container">
                <div class="row g-5">
                    <div class="col-lg-12">
                        <div class="section-title position-relative pb-3 mb-3">
                            <h1>About Power on boot</h1>
                        </div>
                        <p>The 'Power on Boot' application is designed to automatically initiate the phone's startup process when connected to a power source. This feature ensures that the device powers on seamlessly without manual intervention whenever it is plugged in, providing users with quick and convenient access to their device. The aim is to streamline the user experience, ensuring the device is efficiently powered, conserving energy, and optimizing performance for a smoother operation.</p>
                        <h4><b>Why Power on Boot?</b></h4>
                        <div class="row g-0 mb-3">
                            <h6 class="mb-3"><i class="text-primary me-3"></i><b>Convenience::</b>Automatically starting the device when connected to power eliminates the need for users to manually power on the device. This convenience ensures that the device is ready for use as soon as it is connected to a power source.</h6>
                            <h6 class="mb-3"><i class="text-primary me-3"></i><b>Efficiency:</b>By automatically initiating the startup process, the feature optimizes the user experience, reducing the time it takes for the device to be operational. This efficiency is particularly beneficial for users who rely on quick access to their devices.</h6>
                            <h6 class="mb-3"><i class="text-primary me-3"></i><b>Conserving Energy:</b>The ability to power off the device when disconnected from the power source helps conserve battery life. This is useful for users who want to manage power consumption and extend the duration between charges.</h6>
                        </div>
                        <h4><b>Key Features</b></h4>
                        <div class="row g-0 mb-3">
                            <h6 class="mb-3"><i class="text-primary me-3"></i><b>Automatic Device Startup:</b>Initiates the device's startup process automatically when connected to a power source. Ensures quick and convenient access to the device without manual intervention.</h6>
                            <h6 class="mb-3"><i class="text-primary me-3"></i><b>Power-Off on Disconnection:</b>Shuts down the device when disconnected from the power source. Helps conserve battery life and manage power consumption.</h6>
                            <h6 class="mb-3"><i class="text-primary me-3"></i><b>Optimized Performance:</b>Disables unnecessary applications (Bloatware) automatically to enhance overall device performance. Contributes to a smoother and more responsive user interface.</h6>
                        </div>
                        <h4><b>How to Login</b></h4>
                        <ol>
                            <li>After the purchase access cloud through URL: <a href="https://app.packagedisabler.com/">https://app.packagedisabler.com/</a></li>
                            <li>On the login page enter email id and password. (Use the email id and password entered during the purchase)</li>
                            <li>After logging in, user will directed to the dashboard page. User can download mobile application from the 'DOWNLOAD APK' section on the page or utilize the link shared via email upon purchase.</li>
                            <li>
                                Afterward, open the Power on Boot app on your device. On the initial screen, you will find two login options.
                                <ol>
                                    <li>
                                        Enter the same email id and password used during the cloud login.
                                    </li>
                                    <li>Scan the QR code displayed in the cloud dashboard.</li>
                                    <div class="position-relative h-100">
                                        <img class="img-fluid" data-wow-delay="0.9s" :src="appLogin" alt="App Login">
                                        <img class="img-fluid" data-wow-delay="0.9s" :src="WebQrCode" alt="Login Qr Code">
                                    </div>
                                </ol>
                            </li>
                            <li>
                                Upon successful login, users will have directed to main window.
                                <div class="position-relative h-100">
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="appHomeScreen" alt="App Home Screen">
                                </div>
                            </li>
                            <li>
                                On the screen user have option to ‘Enable power on boot’ and ‘Shutdown when power disconnect’
                                <div class="position-relative h-100">
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="appHomeScreenDetail" alt="App Home Screen">
                                </div>
                            </li>
                            <li>
                                Additionally, users have the option to schedule the shutdown of the device. This feature is available only when the power on boot is disabled. Users can set up scheduled shutdown times on a daily or weekly basis according to their preferences and needs.
                                <div class="position-relative h-100">
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="appScheduleScreen" alt="App Home Screen">
                                </div>
                            </li>
                        </ol>
                        <h4><b>Frequently Asked Questions</b></h4>
                        <div class="accordion" v-if="tableData.length > 0" id="faqExample">
                            <div class="card" v-for="(item, index) in tableData" :key="item._id">
                                <div class="card-header p-2" :id="'heading'+index">
                                    <h5 class="mb-0">
                                    <button class="btn btn-link collapsed" type="button" data-toggle="collapse" :data-target="'#collapse'+index" aria-expanded="false" :aria-controls="'collapse'+index">
                                    {{ item.question }}
                                    </button>
                                </h5>
                                </div>
                                <div :id="'collapse'+index" :class="{ show: index==0 }" class="collapse" :aria-labelledby="'heading'+index" data-parent="#faqExample">
                                    <div class="card-body" v-html="item.answer">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- About End -->
    </div>
</template>
<script>
import PaymentService from "../services/PaymentService";
export default {
    props: {
        appLogin: {
            type: String,
            default: "./img/pob/appLogin.png",
        },
        appHomeScreen: {
            type: String,
            default: "./img/pob/appHomeScreen.png",
        },
        appHomeScreenDetail: {
            type: String,
            default: "./img/pob/appHomeScreenDetail.png",
        },
        appScheduleScreen: {
            type: String,
            default: "./img/pob/appScheduleScreen.png",
        },
        WebQrCode: {
            type: String,
            default: "./img/keymapper/WebQrCode.png",
        },
    },  
    data() {
        return {
            tableData: [
                {
                    _id: 1,
                    question: "1. How to purchase the Power on Boot app?",
                    answer:"User can purchase the app from <a href='https://www.packagedisabler.com/'>https://www.packagedisabler.com/</a>"
                },
                {
                    _id: 2,
                    question: "2. How to download the Power on Boot app?",
                    answer:"After the purchase user will receive the email with apk download link or download the app from the portal (<a href='https://app.packagedisabler.com/login'>https://app.packagedisabler.com/login</a>)."
                },
                {
                    _id: 3,
                    question: "3. How to login into the portal?",
                    answer:"User can login to the portal (<a href='https://app.packagedisabler.com/login'>https://app.packagedisabler.com/login</a>) with email id and password, use the same email id and password used during the purchase. "
                },
                {
                    _id: 4,
                    question: "4. How to login to the application after purchasing the app?",
                    answer:"On the login screen, either user can enter email id and password to login or scan the QR code. QR code available in the portal dashboard."
                },
                {
                    _id: 5,
                    question: "5. Did Power on Boot apps work in all Android devices?",
                    answer:"No. Bootapps only available to Samsung devices."
                },
                {
                    _id: 6,
                    question: "6. If purchased for 1 device and wanted to purchase more devices, how to purchase? ",
                    answer:"Navigate to the could portal homepage and utilize the 'BUY PLAN' option; there you will find the option to update your plan."
                },
                {
                    _id: 7,
                    question: "7. Why I am not able to login?",
                    answer:"Check the license status in the cloud portal."
                },
                {
                    _id: 8,
                    question: "8. Can I white label this app?",
                    answer:"Please contact the support team for further details."
                },
            ],
            priceDetail: "",
        }
    },
    methods: {
        formatCurrency(amount) {
            let formatter = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
                minimumFractionDigits: 2
            })
            return formatter.format(amount);
        },
        async productPriceDetail() {
            let data = { onetimeIdentifier: "POBOT", recurringIdentifier: "POB" }
            await PaymentService.productPriceDetail(data)
            .then((response) => {
                this.priceDetail = response.data.data; 
            }).catch((e) => {
                this.$toast.error(e.response.data.respones_msg);
            });
        },
    },
    beforeMount() {
        this.productPriceDetail();
    },  
    created () {
        let currentUrl = window.location.href;
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical !== null) {
            canonical.href = currentUrl;
        }
    },
}
</script>